import { render, staticRenderFns } from "./MedicationList.vue?vue&type=template&id=85097716"
import script from "./MedicationList.vue?vue&type=script&lang=js"
export * from "./MedicationList.vue?vue&type=script&lang=js"
import style0 from "./MedicationList.vue?vue&type=style&index=0&id=85097716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports